import { useTheme } from "@material-ui/core/styles";
import GenericBanner from "./GenericBanner";
import type { SxProps } from "@material-ui/system";
import type { CSSProperties } from "react";

// ----------------------------------------------------------------------

type InfoBannerProps = {
  sx?: SxProps;
  style?: CSSProperties;
  title: string;
  content: JSX.Element;
};

export default function InfoBanner({ sx, style, title, content }: InfoBannerProps) {
  const theme = useTheme();

  return (
    <>
      <GenericBanner
        sx={sx}
        style={style}
        title={title}
        content={content}
        backgroundColor={theme.palette.info.lighter}
        titleTextColor={theme.palette.info.main}
        bodyTextColor={theme.palette.primary.dark}
      />
    </>
  );
}
